module.exports = __webpack_public_path__ + "static/media/cloudlinux.a95fe578.svg";